import type {
  ComponentRegistry,
  ComponentRenderProps,
} from "@json-render/react";

import { ReportDateFromProps } from "@/components/ui/report/ReportDate/ReportDateSpec";
import { ReportFooterFromProps } from "@/components/ui/report/ReportFooter/ReportFooterSpec";
import { ReportHeaderFromProps } from "@/components/ui/report/ReportHeader/ReportHeaderSpec";
import { ReportHighlightFromProps } from "@/components/ui/report/ReportHighlight/ReportHighlightSpec";
import { ReportSectionFromProps } from "@/components/ui/report/ReportSection/ReportSectionSpec";
import {
  ReportTableOfContents,
  type ReportTableOfContentsEntry,
} from "@/components/ui/report/ReportTableOfContents/ReportTableOfContents";

const ReportTableOfContentsFromProps = ({ element }: ComponentRenderProps) => {
  // Herald authors it with no props; entries are only filled in by prepareReportSpecForRender.
  const { sections = [] } = element.props as {
    sections?: ReportTableOfContentsEntry[];
  };

  return <ReportTableOfContents sections={sections} />;
};

/** Report components available at render time but not in the Herald prompt catalog. */
export const reportRendererRegistry: ComponentRegistry = {
  ReportDate: ReportDateFromProps,
  ReportFooter: ReportFooterFromProps,
  ReportHeader: ReportHeaderFromProps,
  ReportHighlight: ReportHighlightFromProps,
  ReportSection: ReportSectionFromProps,
  ReportTableOfContents: ReportTableOfContentsFromProps,
};
